import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// plugin
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

//locale (optional)
import 'dayjs/locale/en';
dayjs.locale('en');

export default dayjs;
